module.exports = __webpack_public_path__ + "img/menu-off_01.f5184b08.png";